import { render, staticRenderFns } from "./EntityHeader.vue?vue&type=template&id=681a0aae&scoped=true&"
import script from "./EntityHeader.vue?vue&type=script&lang=ts&"
export * from "./EntityHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EntityHeader.vue?vue&type=style&index=0&id=681a0aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a0aae",
  null
  
)

export default component.exports